// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"655":"component---src-pages-universidad-nacional-de-asuncion-jsx","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"655":"8a9c571ccd749b295eec","678":"d32f6d7afc6da6aea737","883":"9eff23f09c9f28941728"}[chunkId] + ".js";
};